import { render, staticRenderFns } from "./RRApplicationPhysicalList.vue?vue&type=template&id=77e98ee3&scoped=true&"
import script from "./RRApplicationPhysicalList.vue?vue&type=script&lang=js&"
export * from "./RRApplicationPhysicalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e98ee3",
  null
  
)

export default component.exports